// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "d6ff4921" + "-1791306520770.js";
};